import {ComponentCustomProperties, getCurrentInstance} from 'vue';

/**
 * Shortcut for accessing context and to replace `this` when migrating to composition api
 * ### ⚠️ Only use inside `setup` function or in a composable
 *
 * @example
 *  ```ts
 *  setup() {
 *     const {$msg} = useGlobalProperties();
 *  }
 *  ```
 */
export function useGlobalProperties() {
    const app = getCurrentInstance();
    if (app?.appContext) {
        return app?.appContext.config.globalProperties as ComponentCustomProperties;
    }
    throw new Error('Only use "useContext" inside setup function or in a composable');
}
